// ChatBlob.js
// Update import to include useEffect
import React, { useState, useEffect } from 'react'
import ContentRenderer from '../ContentRenderer'
import constants, { BASE_QUERYURL, BASE_URL, getInitials } from '../constants'
import { useDispatch, useSelector } from 'react-redux'
import { addSource } from '../../slice/sourceSlice'
import { fetchPDF } from '../../slice/pdfViewslice'
import CommentSection from './CommentSection';

function sanitizeTitleForId(title) {
    return title
      ? title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
      : '';
  }

const ChatBlob = ({ user, message, taskId, historyId, openSidebar, onCommentUpdate }) => {
    const dispatch = useDispatch();
    const name = localStorage.getItem("name");
    const userId = localStorage.getItem("id");
    const taskID = useSelector((state) => state.dropdown.id);
    const abr = getInitials(name);
    const [isShowContext, setIsShowContext] = useState(false);

   // for comment section
   const [comments, setComments] = useState({});

   // Add useEffect to load existing comments from message data
   useEffect(() => {
    console.log('Message:', message);
     if (message && message.comment) {
       // Create a comment object from the existing comment
       const commentObj = {
         text: message.comment,
         user: { name: name },
         timestamp: new Date()
       };
       
       // Set it in the local state
       setComments(prevComments => ({
         ...prevComments,
         [message.id || "default"]: commentObj
       }));
     }
   }, [message, name]);
// console.log('summit',comments);
// Add this function to handle adding comments
// Update the handleAddComment function to support single comment with editing
// Update the handleAddComment function to call the API
const handleAddComment = async (answerId, comment) => {
  // Store locally first
  setComments(prevComments => ({ 
    ...prevComments,
    [answerId]: comment
  }));
  
  // Notify parent component about the comment update
  if (onCommentUpdate && typeof onCommentUpdate === 'function') {
    onCommentUpdate(comment.text);
  }
  
  // Call API to update the comment
  try {
    const response = await fetch(`${BASE_QUERYURL}/update-comment`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        comment: comment.text,
        // user_id: userId,
        // task_id: taskId || taskID,
        //  history_id: historyId,
        question_id: message.id // Assuming message contains questionId
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Failed to save comment:', errorData);
    } else {
      console.log('Comment saved successfully');
    }
  } catch (error) {
    console.error('Error saving comment:', error);
  }
};


    // Simplified message content handling
    const messageContent = typeof message.content === 'string' 
        ? message.content 
        : message.content?.content || '';
        
    // Get title if available
    const messageTitle = message.title || '';

    const sources = message.sources || message.source || [];

    const [loadingPdf, setLoadingPdf] = useState({});

    const handleSourceClick = async (filename, page) => {
        // Open the sidebar first
        openSidebar();
        
        // Set loading state for this specific source
        setLoadingPdf(prev => ({ ...prev, [`${filename}-${page}`]: true }));

        try {
            // Check which tab is currently active before opening the PDF
            const currentTab = localStorage.getItem('currentActiveTab');
            console.log('Current active tab before PDF open:', currentTab);
            
            // If we're in the Dateien tab, remember to return there
            if (currentTab === 'files') {
                localStorage.setItem('pdfOpenedFromTab', 'files');
                console.log('Will return to Dateien tab after closing PDF');
            } else {
                // Only set tasks tab if we're not explicitly in files tab
                localStorage.setItem('pdfOpenedFromTab', 'tasks');
            }
            
            // Get ID of the message/question that contains this source reference
            if (message) {
                // If we have a title that matches a question title (like "Spill"),
                // store that as our reference to find later
                let questionTitle = '';
                if (message.title) {
                    questionTitle = message.title;
                    console.log('Found question title:', questionTitle);
                }
                
                // Store both ID and title to ensure we can find the right question
                localStorage.setItem('pdfSourceMessageId', message.id || '');
                localStorage.setItem('pdfSourceMessageTitle', questionTitle);
                
                // Store the current timestamp for reference
                localStorage.setItem('pdfOpenTimestamp', Date.now().toString());
            }
            
            // Then dispatch the source actions with page number
            dispatch(addSource({ filename, page: parseInt(page) }));
            
            if (userId && taskId) {
                await dispatch(fetchPDF({ 
                    userId, 
                    taskId: taskId, 
                    filename,
                    historyId: historyId,
                    page: parseInt(page)
                })).unwrap();
            }
        } catch (error) {
            console.error('Error loading PDF:', error);
        } finally {
            // Clear loading state
            setLoadingPdf(prev => ({ ...prev, [`${filename}-${page}`]: false }));
        }
    };

        // Function to render content with clickable source references
   

    console.log(message.context,'context')
    return (
        <div
            id={messageTitle ? `chat-message-${sanitizeTitleForId(messageTitle)}` : undefined}
            className={`flex w-full gap-5 ${user !== "user" ? "justify-start" : "justify-end "} ${user === "user" ? "pr-10 " : "pl-5" }`}>                       
                {user && (
                    user !== "user" &&
                    <button
                    type="button"
                    className={`ml-3 inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-custom-yellow w-10 h-10`}
                >
                    {user === "user" ? (
                        abr
                    ) : (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M9.83705 9.63783L11.383 5H12.3317L13.8776 9.63783L18.5154 11.1838V12.1325L13.8776 13.6784L12.3317 18.3162H11.383L9.83705 13.6784L5.19922 12.1325V11.1838L9.83705 9.63783Z" fill="white" />
                        </svg>
                    )}
                </button>
                )}
                
                <div className={`${user === "user" ? "bg-custom-gray_white" : "bg-white w-full"} p-3  rounded-lg`}>
                {/* Display title if available */}
                {user !== "user" && messageTitle && (
  <div
    id={messageTitle ? `chat-title-${sanitizeTitleForId(messageTitle)}` : undefined}
    className={`mb-2 w-fit pr-10 pl-10 rounded-xl font-semibold chat-title
    ${user !== "user" ? "bg-custom-yellow text-white" : "text-custom-yellow"}
  `}
  >
    {messageTitle}
  </div>
)}
                {user !== "user" ? (
                    <div>
                        {/* <button 
                            onClick={() => setIsShowContext(!isShowContext)}
                            className="mb-2 text-blue-500 hover:text-blue-700"
                        >
                            {isShowContext ? 'Hide Context' : 'Show Context'}
                        </button> */}
                        
                        {isShowContext ? (
                            message?.context?.map((ctx, index) => (
                                <div key={index}>
                                    <h1 className='font-bold text-lg'>Documents {index + 1}</h1>
                                    <ContentRenderer content={ctx.text} />
                                    <div className='text-sm text-gray-500'>
                                        Source: {ctx.Dateiname} (Page {ctx.Seitenzahl})
                                    </div>
                                </div>
                            ))
                        ) : (
                            <ContentRenderer content={messageContent} />
                        )}
                           {isShowContext === false && sources.length > 0 && sources.map((source, index) => (
                        <div key={index} className='flex items-start justify-start '>
                            <div 
                                className={`bg-custom-gray_white cursor-pointer hover:bg-gray-200 transition-colors duration-200 p-2 rounded flex items-center gap-2 ${loadingPdf[`${source.filename}-${source.page}`] ? 'opacity-50' : ''}`}
                                onClick={() => !loadingPdf[`${source.filename}-${source.page}`] && handleSourceClick(source.filename, source.page)}
                            >
                                <h1 className="text-sm text-blue-600">Source: {source.filename} (Page {source.page})</h1>
                                {loadingPdf[`${source.filename}-${source.page}`] && (
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                )}
                            </div>
                        </div>

                    ))}
                            {/* Fix the JSX comment that was causing issues */}
                            <CommentSection 
                              user={user === "user" ? { name: name } : { name: name }}
                              answer={messageContent}
                              onAddComment={(comment) => handleAddComment(message.id || "default", comment)} 
                              existingComment={comments[message.id || "default"] || null}
                              isShowContext={isShowContext}
                              setIsShowContext={setIsShowContext} 
                            />
                           
                        </div>
                    ) : (
                        <ContentRenderer content={messageContent} />
                        
                    )}
                    <div>
                    
                   
                </div>
                </div>

                {user && (
                    user === "user" &&
                    <button
                        type="button"
                        className={` bg-custom-yellow ml-3 inline-flex items-center font-semibold p-2 border border-transparent rounded-full shadow-sm text-white bg-custom-yellow w-10 h-10`}
                    >
                            {abr}
                    </button>
                )}

        </div>
    );
};

export default ChatBlob;